import { useSiteState } from 'siteState/shared'
import useCancelModal, { Callbacks } from './useCancelModal'
import { useCallback, useId } from 'react'
import useLocationState from '../../FilterFields/hooks/useLocationState'

export default function useCancelChanges() {
  const { persistentSelection, discardPersistentSelection } = useLocationState()
  const { open } = useCancelModal()
  const [_, setEditCallbacks] = useSiteState<Record<string, Callbacks>>(
    'cancel-modal-callbacks'
  )
  const id = useId()

  const confirmIfPendingChanges = useCallback(
    (fn: () => void, onSuccess?: () => void, onCancel?: () => void) => {
      if (persistentSelection) {
        setEditCallbacks({
          [id]: {
            onSucceed: () => {
              setEditCallbacks((old) => {
                delete old[id]
                return old
              })
              discardPersistentSelection()
              onSuccess?.()
            },
            onCancel: () => {
              setEditCallbacks((old) => {
                delete old[id]
                return old
              })
              onCancel?.()
            }
          }
        })
        open(id)
        return
      }

      fn()
    },
    [
      discardPersistentSelection,
      id,
      open,
      persistentSelection,
      setEditCallbacks
    ]
  )

  return {
    confirmIfPendingChanges
  }
}
